import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { uniq } from 'lodash';

import useSite from '../../../../store/hooks/useSite';
import useSiteDevices from '../../../../store/hooks/useSiteDevices';
import AnalysisPage from '../../Analysis';

export default function Analysis() {
  const { id } = useSelector((state) => state.pages.site);
  const site = useSite(id);

  const { meters, inverters, sensors: siteSensors } = useSiteDevices(id);

  const allSensors = useSelector((state) => state.sensors.data);

  // Inverters can be assigned sensors from other sites, which must be included.
  const sensors = useMemo(() => {
    const sensorIds = uniq([
      ...siteSensors,
      ...inverters.map((inverter) => inverter.site_id),
    ]);
    return allSensors.filter((sensor) => sensorIds.includes(sensor.sensor_id));
  }, [inverters, allSensors, siteSensors]);

  return (
    <AnalysisPage
      resource={site}
      timezone={site.timezone}
      sites={[site]}
      meters={meters}
      inverters={inverters}
      sensors={sensors}
    />
  );
}
